<template>
  <div class="koc-tab-wrapper">
    <div
      :class="{kol: kolStyle}"
      class="koc-tab-list-container"
    >
      <ul
        class="koc-tab-list"
        role="tablist"
      >
        <li
          v-for="(tab, i) in tabs"
          :key="i"
          :class="[ tab.isDisabled ? 'koc-tab-disabled' : '', tab.isActive ? 'koc-tab-active' : '' ]"
          class="koc-tab-item"
          role="presentation"
        >
          <a
            :aria-controls="tab.hash"
            :aria-selected="tab.isActive"
            :class="[ tab.isDisabled ? 'koc-tab-disabled' : '', tab.isActive ? 'koc-tab-active' : '' ]"
            :href="tab.hash"
            class="koc-tab-link"
            role="tab"
            @click="selectTab(tab.hash, $event)"
            v-html="tab.header"
          />
        </li>
      </ul>
      <div class="koc-mobiletab-icon-container">
        <a
          v-if="showMobileTabs"
          class="koc-mobiletab-icon-link"
          @click.stop="toggleMobileTabs(false)"
        >
          <font-awesome-icon
            :icon="['fa', 'rectangle-xmark']"
            class="koc-mobiletab-icon"
          />
        </a>
        <a
          v-else
          class="koc-mobiletab-icon-link"
          @click.stop="toggleMobileTabs(true)"
        >
          <font-awesome-icon
            :icon="['fa', 'ellipsis']"
            class="koc-mobiletab-icon"
          />
        </a>
      </div>
    </div>
    <div class="koc-tab-panels-wrapper">
      <slot />

      <div
        v-show="showMobileTabs"
        class="koc-mobiletab-container"
      >
        <div class="koc-mobiletab-list-wrapper">
          <ul
            class="koc-mobiletab-list"
          >
            <li
              v-for="(tab, i) in tabs"
              :key="i"
              :class="[ tab.isDisabled ? 'koc-mobiletab-disabled' : '', tab.isActive ? 'koc-mobiletab-active' : '' ]"
              class="koc-mobiletab-item"
              role="presentation"
            >
              <a
                :aria-controls="tab.hash"
                :aria-selected="tab.isActive"
                :class="[ tab.isDisabled ? 'koc-mobiletab-disabled' : '', tab.isActive ? 'koc-mobiletab-active' : '' ]"
                :href="tab.hash"
                class="koc-mobiletab-link"
                role="tab"
                @click="selectTab(tab.hash, $event)"
                v-html="tab.header"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./tabs.js"></script>
<style lang="scss" scoped src="./tabs.scss"></style>
